export function decodeEmail(divWithEmails) {
  // This function is for decoding emails that we get from agreement checkboxes.
  // For now, they are encoded and without it will see only [email protected] line.
  // Also, the link is broken on it, so here it is changed to normal "mailto".
  /* eslint-disable no-restricted-syntax */
  const emails = divWithEmails.getElementsByClassName("__cf_email__");

  for (const email of emails) {
    let s, j, c;
    const a = email.dataset.cfemail;
    s = "";
    const r = parseInt(a.substr(0, 2), 16);
    for (j = 2; a.length - j; j += 2) {
      /* eslint-disable no-bitwise */
      c = parseInt(a.substr(j, 2), 16) ^ r;
      s += String.fromCharCode(c);
    }
    s = document.createTextNode(s);
    email.parentElement.setAttribute("href", `mailto:${s.textContent}`);
    email.parentNode.replaceChild(s, email);
  }
  return divWithEmails;
}
